import React from 'react';
import { Scale, Bird, Users, Gavel } from 'lucide-react';
import { pathToSalvation } from '../data/mock';

const iconMap = {
  'scale': Scale,
  'bird': Bird,
  'users': Users,
  'balance-scale': Gavel
};

const PathToSalvation = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {pathToSalvation.title}
          </h2>
          <p className="text-xl font-semibold text-orange-600 mb-6">
            {pathToSalvation.subtitle}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {pathToSalvation.content}
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {pathToSalvation.principles.map((principle, index) => {
            const Icon = iconMap[principle.icon];
            const colors = [
              { bg: 'bg-blue-50', border: 'border-blue-600', icon: 'text-blue-600' },
              { bg: 'bg-yellow-50', border: 'border-yellow-600', icon: 'text-yellow-600' },
              { bg: 'bg-red-50', border: 'border-red-600', icon: 'text-red-600' },
              { bg: 'bg-orange-50', border: 'border-orange-600', icon: 'text-orange-600' }
            ];
            const color = colors[index % colors.length];

            return (
              <div 
                key={index}
                className={`${color.bg} p-6 rounded-xl border-2 ${color.border} transform hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-xl`}
              >
                <div className={`w-14 h-14 ${color.bg} rounded-full flex items-center justify-center mb-4 border-2 ${color.border}`}>
                  <Icon className={`w-7 h-7 ${color.icon}`} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {principle.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {principle.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl max-w-4xl mx-auto">
          <img 
            src={pathToSalvation.image} 
            alt="Buddhist Dhamma Wheel" 
            className="w-full h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent flex items-end">
            <div className="p-8 text-white">
              <h3 className="text-2xl font-bold mb-2">The Dhamma Wheel</h3>
              <p className="text-lg text-blue-100">Symbol of Buddhist teachings and the path to enlightenment</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PathToSalvation;
